<script>
  import { onMount } from 'svelte';
  import Button from '../../Common/Button.svelte';
  import CreateChannel from './CreateChannel.svelte';
  import Dialog from '../../Common/Dialog/Dialog.svelte';
  import { addChannel, listenToChannels } from '../../../Api/messagesApi';
  import { selectedChannelId } from '../../../Store/feeds-store';

  let chatConfigOpen = false;
  let createChannelOpen = false;
  let isCreatingChannel = false;

  $: channels = [];

  onMount(async () => {
    await listenToChannels(
      (snapShot) => {
        const channelData = [];
        snapShot.forEach(function (doc) {
          channelData.push({ ...doc.data(), id: doc.id });
        });
        if (channelData.length) {
          channels = channelData.sort((a, b) => {
            const nameA = a.title.toUpperCase();
            const nameB = b.title.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
          channels.sort((a, b) => b.live - a.live);
        }
      },
      (error) => {
        console.log(error.message);
      },
    );
  });

  const onNewFeedClicked = () => {
    createChannelOpen = !createChannelOpen;
  };

  const onCreateChannel = async (e) => {
    isCreatingChannel = true;
    await addChannel(e.detail);
    isCreatingChannel = false;
    createChannelOpen = false;
  };

  const onCancelClicked = () => {
    createChannelOpen = !createChannelOpen;
  };

  const onChannelClicked = (channel) => {
    selectedChannelId.set(channel.id);
  };

  const onCloseConfig = () => {
    chatConfigOpen = false;
  };
</script>

<div class="channels-container">
  <header>
    <h3>Feeds</h3>
    <div class="btn-container">
      <Button secondary on:click={onNewFeedClicked}>+ Ny feed</Button>
    </div>
  </header>
  <div class="channels">
    {#if channels.length}
      {#each channels as channel}
        <div
          class="channel-container"
          class:live={channel.live === true}
          class:selected={$selectedChannelId === channel.id}
          on:click={() => onChannelClicked(channel)}
        >
          <p class="name">{channel.title}</p>
          <div class="light" class:live={channel.live === true}>
            {channel.live ? 'Live' : '-'}
          </div>
        </div>
      {/each}
    {/if}
  </div>
</div>

<CreateChannel
  open={createChannelOpen}
  on:ok={onCreateChannel}
  on:cancel={onCancelClicked}
  {isCreatingChannel}
/>

<Dialog open={chatConfigOpen} on:cancel={onCloseConfig} />

<style src="./channels.scss">
</style>
